import { includes } from 'lodash';
import { CONNECTION_CATEGORY_BUCKET_TYPE_FILES } from 'js/constants/connectionCategories';
import { FileUtil } from 'new/utils/FileUtil';

export function useFilePath(name, sourceType, sourceConfig) {
  if (!includes(CONNECTION_CATEGORY_BUCKET_TYPE_FILES, sourceType)) {
    return name;
  }

  return FileUtil.getFilePath({
    file: { name },
    sourceConfig,
    sourceType,
  });
}
